module.exports = __webpack_public_path__ + "img/5.1bd7a039.jpg";